// @flow
import { flatten, prop, groupBy, path } from "ramda"
import { activities } from "data/app/constants"
import type { ProductGroupCountryAggregator } from "data/locations/types"
import surfImg from "./images/surf.jpg"
import supImg from "./images/sup.jpg"
import roadBikeImg from "./images/road_bike.jpg"
import mountainBikeImg from "./images/mountain_bike.jpg"
import snowboardImg from "./images/snowboard.jpg"
import skiImg from "./images/ski.jpg"
import splitboardImg from "./images/splitboard.jpg"

export type LocationsPerActivity = {
  activity: string,
  locations: number,
}

export const getLocationsNumberPerProductGroup = (
  data: ProductGroupCountryAggregator[],
): LocationsPerActivity[] => {

  const locationsPerActivity = data.map(
    activity => ({
      activity: activity.name,
      locations: flatten(activity.countries.map(country => country.locations)).length,
    })
  )

  return locationsPerActivity
}

const mapLocations = (
  data: {
    [index : string] : LocationsPerActivity[]
  },
  key: string,
): string => {
  if (!path([key], data)) return "0"

  return data[key].map(d => d.locations).join()
}

export const getProductGroups = (
  locationsPerActivity: LocationsPerActivity[],
) => {
  const data = groupBy(prop("activity"), locationsPerActivity)

  return {
    ocean: [
      {
        name: "surf",
        activity: activities.SURF,
        image: surfImg,
        locations: mapLocations(data, "surfs"),
      },
      {
        name: "sup",
        activity: activities.SUP,
        image: supImg,
        locations: mapLocations(data, "sups"),
      },
    ],
    mountain: [
      {
        name: "ski",
        activity: activities.SKI,
        image: skiImg,
        locations: mapLocations(data, "skis"),
      },
      {
        name: "snowboard",
        activity: activities.SNOWBOARD,
        image: snowboardImg,
        locations: mapLocations(data, "snowboards"),
      },
      {
        name: "splitboard",
        activity: activities.SPLITBOARD,
        image: splitboardImg,
        locations: mapLocations(data, "splitboards"),
      },
    ],
    wheels: [
      {
        name: "road bike",
        activity: activities.ROAD_BIKE,
        image: roadBikeImg,
        locations: mapLocations(data, "road_bikes"),
      },
      {
        name: "mountain bike",
        activity: activities.MOUNTAIN_BIKE,
        image: mountainBikeImg,
        locations: mapLocations(data, "mountain_bikes"),
      },
    ],
  }
}



// WEBPACK FOOTER //
// ./src/pages/Explore/helpers.js